import React from "react";

const getLandingPageSteps = () => {
  return [
    {
      target: '#landing-page-merlin',
      id: 'landing.assistant.welcome',
      disableOverlay: true,
      disableBeacon: true,
      placement: 'top'
    }
  ]
};

export default getLandingPageSteps;
